import { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

interface BlockerBlocked {
  state: 'blocked';
  proceed: () => void;
  reset: () => void;
}

export const useBlockNavigation = (blockCondition: () => boolean) => {
  const [showModal, setShowModal] = useState(false);
  const [blocker, setBlocker] = useState<BlockerBlocked | null>(null);

  const navigationBlocker = useBlocker(blockCondition);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (blockCondition()) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [blockCondition]);

  useEffect(() => {
    if (navigationBlocker.state === 'blocked') {
      setBlocker(navigationBlocker as BlockerBlocked);
      setShowModal(true);
    }
  }, [navigationBlocker]);

  const handleProceed = () => {
    if (blocker) {
      blocker.proceed();
      setShowModal(false);
      setBlocker(null);
    }
  };

  const handleStay = () => {
    if (blocker) {
      blocker.reset();
      setShowModal(false);
      setBlocker(null);
    }
  };

  return { showModal, handleProceed, handleStay };
};
